:host {
  display: block;
  font-family: var(--sc-font-sans);
  overflow-wrap: anywhere;
}

.item {
  box-sizing: border-box;
  margin: 0px;
  min-width: 0px;
  display: flex;
  gap: var(--sc-spacing-large);
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  border-bottom: none;
  container-type: inline-size;

  &__text-container {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    display: flex;
    flex-direction: column;
    gap: var(--sc-product-line-item-line-gap, 6px);
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    border-bottom: none;
  }

  &__row {
    display: flex;
    gap: 18px;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;

    &.stick-bottom {
      margin-top: auto;
    }
  }

  &__scratch-price {
    text-decoration: line-through;
    font-size: var(--sc-font-size-small);
    line-height: 1;
    color: var(--sc-input-help-text-color);
    white-space: nowrap;
  }

  &__remove-container {
    display: flex;
    gap: 6px;
    align-items: center;
    line-height: 1;
    cursor: pointer;
    color: var(--sc-input-help-text-color);
    font-size: var(--sc-input-help-text-font-size-medium);
  }

  &__add-review {
    sc-button {
      --sc-input-border-radius-small: var(--sc-input-border-radius-medium);
    }
  }

  &--has-review {
    border-bottom: solid 1px var(--sc-input-border-color, var(--sc-input-border));
    padding-top: var(--sc-spacing-small);
    padding-bottom: var(--sc-spacing-large);

    :host(:first-of-type) & {
      padding-top: 0;
    }
  }
}

.item__text {
  box-sizing: border-box;
  margin: 0px;
  min-width: 0px;
  display: flex;
  gap: 6px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1 1 0%;
}

.item__text-details {
  display: grid;
  gap: var(--sc-product-line-item-line-gap, 6px);
}

.item__title {
  box-sizing: border-box;
  min-width: 0px;
  margin: 0;
  color: var(--sc-line-item-title-color, var(--sc-input-label-color));
  font-size: var(--sc-font-size-medium);
  font-weight: var(--sc-font-weight-semibold);
  line-height: 1;
  cursor: pointer;
  display: -webkit-box;
  display: -moz-box;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -webkit-line-clamp: 3;
  -moz-box-lines: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item__suffix {
  flex: 1;
  box-sizing: border-box;
  margin: 0px;
  min-width: 0px;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: space-between;
  align-items: flex-end;
  min-width: 100px;
  margin-left: auto;
  align-self: center;
}

.product-line-item__removable .item__suffix {
  align-self: flex-start;
}
.product-line-item__editable .item__suffix {
  align-self: flex-start;
}

.product-line-item__purchasable-status {
  font-size: var(--sc-font-size-x-small);
  color: var(--sc-input-error-text-color);
}

.item__price {
  text-align: right;
  max-width: 100%;
  display: grid;
  gap: var(--sc-product-line-item-line-gap, 6px);
}

.item__description {
  color: var(--sc-price-label-color, var(--sc-input-help-text-color));
  font-size: var(--sc-price-label-font-size, var(--sc-input-help-text-font-size-medium));
  line-height: 1;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: var(--sc-product-line-item-line-gap, 6px);
  text-wrap: pretty;

  &:last-child {
    align-items: flex-end;
    text-align: right;
  }
}

.item__image-placeholder {
  width: var(--sc-product-line-item-image-size, 65px);
  height: var(--sc-product-line-item-image-size, 65px);
  background-color: var(--sc-input-border-color, var(--sc-input-border));
  border-radius: 4px;
  flex: 0 0 var(--sc-product-line-item-image-size, 65px);
}

.item__image,
.attachment-thumbnail {
  width: var(--sc-product-line-item-image-size, 65px);
  height: var(--sc-product-line-item-image-size, 65px);
  object-fit: cover;
  border-radius: 4px;
  border: solid 1px var(--sc-input-border-color, var(--sc-input-border));
  display: block;
  box-shadow: var(--sc-input-box-shadow);
  align-self: flex-start;
}

@container (max-width: 380px) {
  .item__image,
  .item__image-placeholder {
    display: var(--sc-product-line-item-mobile-image-display, none);
  }
}

.product__description {
  display: flex;
  gap: 0.5em;
  align-items: center;
}

.price {
  font-size: var(--sc-font-size-medium);
  font-weight: var(--sc-font-weight-semibold);
  color: var(--sc-input-label-color);
  line-height: 1;
  white-space: nowrap;
  display: flex;
  gap: 4px;
  align-items: baseline;
}

.price__description {
  font-size: var(--sc-font-size-small);
  line-height: 1;
  color: var(--sc-input-help-text-color);
  text-align: right;
  white-space: nowrap;
}

.item--is-rtl {
  &.price {
    text-align: right;
  }
  .item__price {
    text-align: left;
  }
}

.base {
  display: grid;
  gap: var(--sc-spacing-x-small);
}

.fee__description {
  color: var(--sc-input-help-text-color);
}

sc-quantity-select::part(base) {
  box-shadow: none;
  background-color: transparent;
}

sc-quantity-select::part(base):not(:focus-within) {
  border-color: transparent;
}

sc-quantity-select::part(input),
sc-quantity-select::part(plus),
sc-quantity-select::part(minus) {
  background-color: transparent;
}

// Line item details — collapsible region shared by bundle components and the note.
.line-item-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: flex-start;
  gap: 0.25em;
  margin-top: var(--sc-spacing-xx-small);
  color: var(--sc-input-label-color);
  font-size: var(--sc-font-size-small);
  line-height: 1.4;
  background: transparent;
  outline: none;

  &:hover,
  &:focus,
  &:focus-visible {
    background: transparent;
  }

  &--clickable {
    cursor: pointer;
  }

  &__content {
    flex: 0 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  // Collapsed: clamp to N lines (default 2) plus the 2px row gaps — `1lh` where supported, `1.4em` fallback.
  &:not(.line-item-details--is-expanded) &__content {
    max-height: calc(var(--sc-line-item-details-collapse-lines, 2) * 1.4em + (var(--sc-line-item-details-collapse-lines, 2) - 1) * 2px);
    max-height: calc(var(--sc-line-item-details-collapse-lines, 2) * 1lh + (var(--sc-line-item-details-collapse-lines, 2) - 1) * 2px);
    overflow: hidden;
  }

  &--is-expanded &__content {
    max-height: none;
    overflow: visible;
  }

  // Inline text flow (not flex) so a long name wraps like a paragraph instead of orphaning the "N ×" prefix on its own line.
  &__row {
    &:empty {
      display: none;
    }
  }

  // Quantity prefix ("2 ×") — only rendered when > 1, same color as the name.
  &__qty {
    margin-inline-end: 0.35em;
  }

  // Variant options ("· Red · Large") — muted, after the name.
  &__variant {
    margin-inline-start: 0.35em;
    color: var(--sc-color-gray-500, var(--sc-input-help-text-color));
  }

  &__note {
    color: var(--sc-color-gray-500, var(--sc-input-help-text-color));
    word-wrap: break-word;
    white-space: normal;
    max-width: 100%;
  }

  &__toggle {
    background: transparent;
    border: 0;
    padding: 0;
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    color: var(--sc-color-gray-500, var(--sc-input-help-text-color));
    cursor: pointer;
    border-radius: var(--sc-border-radius-small);
    transition: color 0.2s ease;
    appearance: none;
    -webkit-appearance: none;
    box-shadow: none;

    &:hover,
    &:focus,
    &:active {
      background: transparent;
      box-shadow: none;
      color: var(--sc-color-gray-700, var(--sc-input-label-color));
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid var(--sc-color-primary-500);
      outline-offset: 2px;
    }
  }

  // Match the design's text-sm (14px / 20px). Don't use --sc-font-size-small
  // here: it's 0.875em and compounds against the container, rendering the
  // label far too small (~11px).
  &__toggle-label {
    font-size: 14px;
    line-height: 20px;
  }

  // Don't override sc-icon's host display — it breaks its --width/--height sizing.
  &__toggle-icon {
    transition: transform 0.2s ease;
    will-change: transform;
  }

  &--is-expanded &__toggle-icon {
    transform: rotate(180deg);
  }
}

// Bundle product count next to the name — inherits the title's color/size (Figma).
.item__title-count {
  margin-inline-start: 0.25em;
}

// Screen-reader-only text (shadow DOM can't reach the global helper class).
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
